import React, { useEffect, useRef, useState } from 'react';
import { portalWindowSvg } from '../../packages/aether-ui/src/artwork';
import { sessionStyles } from './sessionStyles';

export function SessionPanel({ children }: { children: React.ReactNode }) {
    const ref = useRef<HTMLDivElement>(null);
    const [size, setSize] = useState<[number, number]>([460, 260]);
    useEffect(() => {
        const panel = ref.current;
        if (!panel) return;
        const measure = () => {
            const { width, height } = panel.getBoundingClientRect();
            const next: [number, number] = [Math.max(1, Math.ceil(width)), Math.max(1, Math.ceil(height))];
            setSize(previous => previous[0] === next[0] && previous[1] === next[1] ? previous : next);
        };
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(panel);
        return () => observer.disconnect();
    }, []);
    return <div ref={ref} style={{ ...sessionStyles.panel, position: 'relative', background: 'transparent',
        border: 0, borderRadius: 0, boxShadow: 'none', display: 'flex', flexDirection: 'column', overflow: 'visible' }}>
        <div className="session-panel-artwork" aria-hidden="true" style={{ position: 'absolute', inset: -48, pointerEvents: 'none' }}
            dangerouslySetInnerHTML={{ __html: portalWindowSvg(size[0], size[1], 'session-window') }} />
        <div style={{ position: 'relative', minHeight: 0, overflowY: 'auto' }}>{children}</div>
    </div>;
}
